import { observable, action } from "mobx";

class ProfileLocationHoursDialog {
	@observable show = false;

	constructor(rootStore) {
		this.rootStore = rootStore;
	}

	get todayHours() {
		const { profileLocationHoursStore } = this.rootStore.stores;
		const { todayHours } = profileLocationHoursStore;
		return todayHours;
	}

	get hours() {
		const { profileLocationHoursStore } = this.rootStore.stores;
		const { hours } = profileLocationHoursStore.provider;
		return hours;
	}

	get dayList() {
		const { profileLocationHoursStore } = this.rootStore.stores;
		const startDayNum = this.todayHours.dayNum;
		const response = [];
		for (let i = startDayNum; i < 7; i++) {
			response.push(profileLocationHoursStore.dayAbbrev(i));
		}
		for (let i = 0; i < startDayNum; i++) {
			response.push(profileLocationHoursStore.dayAbbrev(i));
		}
		return response;
	}

	get dayListHours() {
		const { profileLocationHoursStore } = this.rootStore.stores;
		const startDayNum = this.todayHours.dayNum;
		const response = [];
		for (let i = startDayNum; i < 7; i++) {
			const dayStr = profileLocationHoursStore.dayStr(i);
			response.push(this.getTimeRange(this.hours[dayStr]));
		}
		for (let i = 0; i < startDayNum; i++) {
			const dayStr = profileLocationHoursStore.dayStr(i);
			response.push(this.getTimeRange(this.hours[dayStr]));
		}
		return response;
	}

	@action
	onClose() {
		this.show = false;
	}

	getTimeRange(day) {
		const { profileLocationHoursStore } = this.rootStore.stores;
		const { start, stop, active } = day;
		if (!active) return "Closed";
		return `${profileLocationHoursStore.getTimeString(
			start
		)} &ndash; ${profileLocationHoursStore.getTimeString(stop)}`;
	}
}

export default ProfileLocationHoursDialog;
